export const hasElements = (arr) => arr && Array.isArray(arr) && arr.length > 0;

export const removeDuplicates = (arr, keyAttribute = undefined) => {
    if (hasElements(arr)) {
        if (keyAttribute) {
            return arr.reduce((newArr, item) => {
                if (!newArr.some((x) => x[keyAttribute] === item[keyAttribute])) {
                    return [...newArr, item];
                }
                return newArr;
            }, []);
        }

        return arr.reduce((newArr, item) => {
            if (!newArr.includes(item)) {
                return [...newArr, item];
            }
            return newArr;
        }, []);
    }
    return arr;
};
